'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiFlashOutline = function TiFlashOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm24.2 6.7h0z m0 0l-4.2 10 8.3 4.8-12.5 11.8 4.2-10-8.3-4.8 12.5-11.8z m0-3.4c-1 0.1-1.7 0.4-2.3 1l-12.5 11.8c-0.8 0.7-1.2 1.7-1 2.8 0.1 1 0.7 2 1.6 2.5l5.8 3.4-3 7.3c-0.6 1.4-0.2 3.1 1.1 4 0.6 0.4 1.3 0.6 1.9 0.6 0.9 0 1.7-0.3 2.3-0.9l12.5-11.9c0.8-0.7 1.2-1.7 1-2.8-0.1-1-0.7-2-1.6-2.5l-5.8-3.3 3-7.2c0.2-0.4 0.3-0.9 0.3-1.4 0-1.9-1.5-3.4-3.3-3.4z' })
        )
    );
};

exports.default = TiFlashOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/flash-outline.js
// module id = 3629
// module chunks = 0